<div style="background: #fbf8ff; height: 100vh">
  <ngx-ui-loader [fgsColor]="'#de3c4c'" [bgsColor]="'#de3c4c'"></ngx-ui-loader>
  <router-outlet></router-outlet>
</div>
